// Light gray background, user cannot edit
export const readOnlyStyle = {
  readOnly: true,
  style: {
    backgroundColor: '#eeeeee',
  },
};
